import React, { useContext, useState } from 'react';
import { TablaFechasVencimiento } from '../../components/hacienda/actividadEconomica/modalTablaFechasVencimiento';
import { AuthContext } from '../../context/auth';
import Footer from '../../components/Footer';
import MenuActividadEconomica from '../../components/hacienda/actividadEconomica/menuActividadEconomica';
import Header from '../../components/Header';
import Barra from '../../components/barra';



const FechasVencimiento = props => {

  const { user } = useContext(AuthContext);
  const [mostrar3, setMostrar3] = useState(true);


  const handleCancela3 = () => {
    setMostrar3(false);
    window.location.href = '/actividadEconomica';

  }

  const handleAceptaFecha = () => {
    setMostrar3(false);
    window.location.href = '/actividadEconomica';
    //alert(localStorage.getItem('nombreempresa'));

    /*localStorage.clear();
    window.location.href='/';*/
  }

  return user && (
    <div style={{ height: "100vh", padding: 0 }}>
      <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
        <Header />
      </div>
      <div className="row col-md-12" style={{ height: "90%", padding: 0, margin: 0 }}>
        <Barra />
        <div className="col-md-10" style={{ height: "100%", padding: 0 }}>
          <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
              <MenuActividadEconomica />
          </div>
          <div className="col-md-12" style={{ height: "90%", padding: 0 }}>
            <TablaFechasVencimiento
              show={mostrar3}
              onHideAcepta={handleAceptaFecha} onHideCancela={handleCancela3} />
          </div>
        </div>
      </div>
    </div>

  );
}



export default FechasVencimiento;